export default {
  ERROR: 'paraNoteContextMenu',
  DELETE: 'delete'
};
